import { httpAPI } from "@/api/httpAPI";
import i18n from '@/i18n';

const favorites = {
    namespaced: true,
    state: {
        favoriteValue: false,
        isFavoriteBtnVisible: false,
    },
    mutations: {
        SET_FAVORITE_VALUE(state, payload) {           
            state.favoriteValue = payload;
        },
        SET_IS_FAVORITE_BTN_VISIBLE(state, payload) {
            state.isFavoriteBtnVisible = payload;
        }
    },
    actions:{
        setFavoritesDefaults({ commit }) {
            commit('SET_FAVORITE_VALUE', false);
            commit('SET_IS_FAVORITE_BTN_VISIBLE', false);
        },
        async getFavoriteStatus({ commit }, { documentId }) {
            var response = await httpAPI({
                    url: `api/actions/getfavorite?document_id=${documentId}`,
                    method: 'GET',
                });

            if (response) {

                if (response.data.Payload.Result == "Ok") {
                    commit('SET_FAVORITE_VALUE', response.data.Payload.Value);
                    commit('SET_IS_FAVORITE_BTN_VISIBLE', true);                    
                }
                else {
                    if (response.data.Payload.MessageKey)
                        this._vm.$notify.alert(this.$t(response.data.Payload.MessageKey));
                }
            }
        },
        async onFavoriteClick({ commit, getters }, { documentId }) 
        {            
            var response = await httpAPI({
                    url: `api/actions/${getters.favoriteValue ? 'unsetfavorite' : 'setfavorite'}?document_id=${documentId}`,
                    method: 'GET',
                });

            if (response) {
                if (response.data.Payload.Result == "Ok") {                    
                    this._vm.$notify.success(getters.favoriteValue ? i18n.t('Документ_удален_из_избранного') : i18n.t('Документ_добавлен_в_избранное'));                   
                    commit('SET_FAVORITE_VALUE', !getters.favoriteValue);
                }
            }
        },
    },
    getters: {
        favoriteValue: (s) => s.favoriteValue,
        isFavoriteBtnVisible: (s) => s.isFavoriteBtnVisible,
    },
};

export default favorites;